import { apiSlice } from '../api/apiSlice'
import VoteType from '../../types/enums/VoteType'
import TargetType from '../../types/enums/TargetType'

const commonUrl = '/votes'

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    vote: build.mutation({
      query: (vote: VoteDTO) => ({
        url: commonUrl,
        method: 'POST',
        body: vote,
      }),
      invalidatesTags: (_result, _error, vote) => [
        { type: vote.targetType === TargetType.COMMENT ? 'Comment' : 'Candidate', id: 'LIST' },
      ],
    }),
  }),
})

export type VoteDTO = {
  targetId: string
  targetType: TargetType
  voteType: VoteType
}

export const { useVoteMutation } = extendedApiSlice